__turbopack_context__.v({
  "caption": "cG-5ha_caption",
  "diagram": "cG-5ha_diagram",
  "diagramFrame": "cG-5ha_diagramFrame",
  "loading": "cG-5ha_loading",
  "loadingSpinner": "cG-5ha_loadingSpinner",
  "mermaidFigure": "cG-5ha_mermaidFigure",
  "spin": "cG-5ha_spin",
  "textAlternative": "cG-5ha_textAlternative",
  "textAlternativeContent": "cG-5ha_textAlternativeContent",
  "textAlternativeSummary": "cG-5ha_textAlternativeSummary",
});
